// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ::ng-deep .p-multiselect {
		min-width: 15rem;
	}

	:host ::ng-deep .multiselect-custom-virtual-scroll .p-multiselect {
		min-width: 20rem;
	}

	:host ::ng-deep .multiselect-custom .p-multiselect-label {
		padding-top: .25rem;
		padding-bottom: .25rem;

	}

	:host ::ng-deep .multiselect-custom .country-item.country-item-value {
		padding: .25rem .5rem;
		border-radius: 3px;
		display: inline-flex;
		margin-right: .5rem;
		background-color: var(--primary-color);
		color: var(--primary-color-text);
	}

	:host ::ng-deep .multiselect-custom .country-item.country-item-value img.flag {
		width: 17px;
	}

	:host ::ng-deep .multiselect-custom .country-item {
		display: flex;
		align-items: center;
	}

	:host ::ng-deep .multiselect-custom .country-item img.flag {
		width: 18px;
		margin-right: .5rem;
	}

	:host ::ng-deep .multiselect-custom .country-placeholder {
		padding: 0.25rem;
	}

	:host ::ng-deep .p-colorpicker {
		width: 2.5em
	}
    `, "",{"version":3,"sources":["webpack://./src/app/argic/view/matrixsearch-wrapper.component.ts"],"names":[],"mappings":"AAAA;EACE,gBAAgB;CACjB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,mBAAmB;EACnB,sBAAsB;;CAEvB;;CAEA;EACC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;EACtC,gCAAgC;CACjC;;CAEA;EACC,WAAW;CACZ;;CAEA;EACC,aAAa;EACb,mBAAmB;CACpB;;CAEA;EACC,WAAW;EACX,mBAAmB;CACpB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC;CACD","sourcesContent":[":host ::ng-deep .p-multiselect {\n\t\tmin-width: 15rem;\n\t}\n\n\t:host ::ng-deep .multiselect-custom-virtual-scroll .p-multiselect {\n\t\tmin-width: 20rem;\n\t}\n\n\t:host ::ng-deep .multiselect-custom .p-multiselect-label {\n\t\tpadding-top: .25rem;\n\t\tpadding-bottom: .25rem;\n\n\t}\n\n\t:host ::ng-deep .multiselect-custom .country-item.country-item-value {\n\t\tpadding: .25rem .5rem;\n\t\tborder-radius: 3px;\n\t\tdisplay: inline-flex;\n\t\tmargin-right: .5rem;\n\t\tbackground-color: var(--primary-color);\n\t\tcolor: var(--primary-color-text);\n\t}\n\n\t:host ::ng-deep .multiselect-custom .country-item.country-item-value img.flag {\n\t\twidth: 17px;\n\t}\n\n\t:host ::ng-deep .multiselect-custom .country-item {\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t}\n\n\t:host ::ng-deep .multiselect-custom .country-item img.flag {\n\t\twidth: 18px;\n\t\tmargin-right: .5rem;\n\t}\n\n\t:host ::ng-deep .multiselect-custom .country-placeholder {\n\t\tpadding: 0.25rem;\n\t}\n\n\t:host ::ng-deep .p-colorpicker {\n\t\twidth: 2.5em\n\t}\n    "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
